module.exports = __webpack_public_path__ + "assets/img/AstonRX-Landing-Page-w540.ff6d5834.jpg";